module.exports = __webpack_public_path__ + "img/hooray.25ffea5a.svg";